import { createRouter, createWebHistory } from 'vue-router'
import Login from '../Login.vue'
import ValidarCuenta from '../views/modules/auth/ValidarCuenta.vue'
import ValidarCambioEmail from '../views/modules/auth/ValidarCambioEmail.vue'
import RestablecerContrasena from '../views/modules/auth/RestablecerContrasena.vue'
import AppGecrosAccess from '../views/modules/auth/AppGecrosAccess.vue'
import PortalHomeLayout from '../views/modules/home/PortalHomeLayout.vue'
import PortalHomeDashboard from '../views/modules/home/PortalHomeDashboard.vue'
import PortalChangePassword from '../views/modules/personal/PortalChangePassword.vue'
import PortalMisDatos from '../views/modules/personal/PortalMisDatos.vue'
import PortalGrupoFamiliar from '../views/modules/personal/PortalGrupoFamiliar.vue'
import PortalHelp from '../views/modules/help/PortalHelp.vue'
import PortalModulePlaceholder from '../views/modules/home/PortalModulePlaceholder.vue'
import store from '../store'

// Temporal hasta version 4.3: Consulta de Internaciones depende de cambios de Historia Clinica.
const TEMPORARILY_DISABLED_PORTAL_MODULES = Object.freeze(['admissions'])

function portalPacienteImplementado() {
  return store.state?.portalConfig?.hospitalConfig?.portalPacienteImplementado === true
}

function autogestionImplementada() {
  return store.state?.portalConfig?.hospitalConfig?.autogestionImplementada === true
}

function isTemporarilyDisabledPortalPath(path) {
  const key = String(path ?? '').trim().replace(/^\/+/, '').split('/')[0]?.toLowerCase()
  return TEMPORARILY_DISABLED_PORTAL_MODULES.includes(key)
}

function appointmentsNuevoBeforeEnter(to, from, next) {
  const token = localStorage.getItem('token')
  const g = store.state?.guestSession
  const guestOk =
    g?.activo === true && String(g.accessToken ?? '').trim() !== ''
  if (token) {
    if (!portalPacienteImplementado()) {
      next({ name: 'login' })
      return
    }
    next()
    return
  }
  if (guestOk) {
    if (!autogestionImplementada()) {
      next({ name: 'login' })
      return
    }
    next()
    return
  }
  if (!autogestionImplementada()) {
    next({ name: 'login' })
    return
  }
  next({ name: 'login', query: { nuevoTurno: 'sesion-requerida' } })
}

const routes = [
  {
    path: '/restablecer-contrasena',
    name: 'restablecer-contrasena',
    component: RestablecerContrasena,
    meta: { requiresAuth: false, showInstitutionalFooter: false },
  },
  {
    path: '/validar-cuenta',
    name: 'validar-cuenta',
    component: ValidarCuenta,
    meta: { requiresAuth: false, showInstitutionalFooter: false },
  },
  {
    path: '/validar-cambio-email',
    name: 'validar-cambio-email',
    component: ValidarCambioEmail,
    meta: { requiresAuth: false, showInstitutionalFooter: false },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false, showInstitutionalFooter: false },
  },
  {
    path: '/app-gecros/:tokenBenef',
    name: 'app-gecros',
    component: AppGecrosAccess,
    meta: {
      requiresAuth: false,
      showInstitutionalFooter: false,
      documentTitle: 'Acceso Gecros',
    },
  },
  {
    path: '/appointments/nuevo',
    name: 'portal-nuevo-turno',
    component: () =>
      import('../views/modules/turnos/PortalAppointmentsNuevo.vue'),
    meta: {
      requiresAuth: false,
      showInstitutionalFooter: true,
      documentTitle: 'Nuevo turno',
    },
    beforeEnter: appointmentsNuevoBeforeEnter,
  },
  {
    path: '/turnos/reserva/:accion',
    name: 'portal-reserva-operacion',
    component: () =>
      import('../views/modules/turnos/PortalReservaOperacion.vue'),
    meta: {
      requiresAuth: false,
      showInstitutionalFooter: true,
      documentTitle: 'Reserva de turno',
    },
  },
  {
    path: '/turnos/confirmar-reserva',
    redirect: (to) => ({
      path: '/turnos/reserva/confirmar',
      query: to.query,
    }),
  },
  {
    path: '/',
    component: PortalHomeLayout,
    meta: { requiresAuth: true, showInstitutionalFooter: true },
    children: [
      {
        path: '',
        name: 'home',
        component: PortalHomeDashboard,
        meta: { showInstitutionalFooter: true },
      },
      {
        path: 'changepassword',
        name: 'portal-change-password',
        component: PortalChangePassword,
        meta: { showInstitutionalFooter: true, documentTitle: 'Cambiar contraseña' },
      },
      {
        path: 'patientdata',
        name: 'portal-mis-datos',
        component: PortalMisDatos,
        meta: { showInstitutionalFooter: true, documentTitle: 'Mis datos' },
      },
      {
        path: 'familygroup',
        name: 'portal-grupo-familiar',
        component: PortalGrupoFamiliar,
        meta: { showInstitutionalFooter: true, documentTitle: 'Grupo familiar' },
      },
      {
        path: 'help',
        name: 'portal-help',
        component: PortalHelp,
        meta: {
          showInstitutionalFooter: true,
          documentTitle: 'Ayuda',
        },
      },
      {
        path: 'ayuda',
        name: 'portal-ayuda',
        component: PortalHelp,
        meta: {
          showInstitutionalFooter: true,
          documentTitle: 'Ayuda',
        },
      },
      {
        path: 'diagimgreports',
        name: 'portal-informes-diagnostico',
        component: () =>
          import('../views/modules/informes/PortalInformesDiagnosticos.vue'),
        meta: { showInstitutionalFooter: true },
      },
      {
        path: 'labreports',
        name: 'portal-resultados-laboratorio',
        component: () =>
          import('../views/modules/informes/PortalResultadosLaboratorio.vue'),
        meta: { showInstitutionalFooter: true },
      },
      {
        path: 'externallabreports',
        name: 'portal-resultados-laboratorio-externos',
        component: () =>
          import('../views/modules/informes/PortalResultadosLaboratorio.vue'),
        meta: { showInstitutionalFooter: true },
      },
      {
        path: 'otherdocuments',
        name: 'portal-otros-documentos',
        component: () =>
          import('../views/modules/informes/PortalOtrosDocumentos.vue'),
        meta: { showInstitutionalFooter: true },
      },
      {
        path: 'appointments',
        name: 'portal-mis-turnos',
        component: () =>
          import('../views/modules/turnos/PortalMisTurnos.vue'),
        meta: { showInstitutionalFooter: true },
      },
      {
        path: 'admissions',
        name: 'portal-internaciones',
        component: () =>
          import('../views/modules/internaciones/PortalInternaciones.vue'),
        meta: { showInstitutionalFooter: true },
      },
      {
        path: 'solicitudEstudios',
        name: 'portal-pedidos-medicos',
        component: () =>
          import('../views/modules/pedidos-medicos/PortalPedidosMedicos.vue'),
        meta: { showInstitutionalFooter: true },
      },
      {
        path: ':moduleSlug',
        name: 'portal-module',
        component: PortalModulePlaceholder,
        meta: { showInstitutionalFooter: true },
        props: (route) => ({
          modulePath: route.params.moduleSlug || '',
        }),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  if (requiresAuth && !portalPacienteImplementado()) {
    next({ name: 'login' })
    return
  }
  if (requiresAuth && !token) {
    const q = to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {}
    next({ name: 'login', query: q })
    return
  }
  if (to.name === 'login' && token && portalPacienteImplementado()) {
    next({ path: '/' })
    return
  }
  if (requiresAuth && isTemporarilyDisabledPortalPath(to.path)) {
    next({ path: '/' })
    return
  }
  next()
})

export default router
